import BaseScene from '@Scenes/BaseScene';

/*--------------- Config ------------------------*/
import * as Scenes from '@Config/scenes';
import { ILeaderboardConfig } from '@Config/leaderboards';

/*--------------- Models ------------------------*/
import EventEmitter from '@Utils/Events/EventEmitter';
import EventChannels from '@Config/event_channels';

import LeaderboardEntry from './LeaderboardEntry';
/*-----------------------------------------------*/

/**
 * Leaderboard Scene
 */
class LeaderboardScene extends BaseScene
{
    private leaderboardEntries: Networks.LeaderboardEntry[];

    private leaderboardEntriesUI: LeaderboardEntry[]

    /**
     * Contructor
     */
    constructor()
    {
        super(Scenes.LEADERBOARD)
    }

    /**
     * Initializes the scene
     * @param leaderboardConfig
     */
    public init(leaderboardSceneData: leaderboardSceneData)
    {
        this.leaderboardEntries = leaderboardSceneData.leaderboardEntries;
    }

    /**
     * Preloads the scene
     * Preloads images etc
     */
    public preload()
    {
        const leaderboardEntries = this.leaderboardEntries;

        for( let leaderboardEntry of leaderboardEntries )
        {
            const player = leaderboardEntry.getPlayer();

            const playerImageKey = `player-${player.getID()}`;

            if( this.textures.exists(playerImageKey) === false)
            {
                this.load.image(playerImageKey, player.getPhoto());
            }
        }

        EventEmitter.emit(Scenes.LEADERBOARD, 'loading_complete');

    }

    /**
     * Creates score scene
     */
    public async create()
    {
        const leaderboardEntries = this.leaderboardEntries;

        if (leaderboardEntries.length > 0)
        {
            this.createLeaderboardEntriesUI(leaderboardEntries);
        }
        else
        {
            this.createNoScoresFoundtext();
        }

        this.enableShutdown();
    }

    /**
     * Creates leaderboard entries
     * @param leaderboardEntries
     */
    private createLeaderboardEntriesUI(leaderboardEntries: Networks.LeaderboardEntry[])
    {
        this.leaderboardEntriesUI = [];

        leaderboardEntries.forEach((leaderboardEntry: Networks.LeaderboardEntry, index) =>
        {
            this.leaderboardEntriesUI.push(new LeaderboardEntry(this, index, leaderboardEntry));
        });
    }

    /**
     * Restarts the scene
     */
    private restartScene = () =>
    {
        this.scene.restart();
    }

    /**
     * Creates no scores found text
     */
    public createNoScoresFoundtext()
    {
        const gameSize = this.getGameSize();
        const fontStyle = { fontFamily: 'Permanent Marker', color: '#000000', fontSize: '25px', align: 'center' };

        const noScoresFoundText = this.add.text(gameSize.width / 2, 200, 'No scores found', fontStyle);
        noScoresFoundText.setOrigin(0.5);
    }

    /**
     * Shuts down the scene
     */
    public shutdown()
    {
        EventEmitter.off(EventChannels.LEADERBOARDS, 'update', this.restartScene);

        this.leaderboardEntriesUI = null;
    }

}

export default LeaderboardScene;

/*---------------------------- Types -----------------------------*/

interface leaderboardSceneData
{
    leaderboard: ILeaderboardConfig,
    leaderboardEntries: Networks.LeaderboardEntry[]
}